export const stripTransientStreamMarkup = (content: string): string => (
  content
    .replace(/<\/?planning>/gi, '')
    .replace(/<\/?final_answer>/gi, '')
);
